import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

export const TableObjectCell: TableValueCellComponent = ({ field, value }) => {
  return (
    <DataTable.Cell style={{ flex: field.width || 1 }}>
      {value?.[field.key]}
    </DataTable.Cell>
  );
};
